import { makeStyles } from "@material-ui/core/styles";
import { MuiRadio } from '../MaterialUIComponents'
import React from 'react';
import theme from '../../../assests/theme'
const useStyles = makeStyles({
    root: {
        color: theme.palette.primary.main,
        '&$checked': {
            color: theme.palette.primary.main,
        },
    },
    checked: {},
})
export default function Radio(props) {
    const classes = useStyles();
    return (<MuiRadio className={classes.root} color="default" {...props} />)
}
